<template>
    <div>

        <div v-html="product.description" />

        <div v-if="product.auto" class="my-1">
            <v-icon color="primary">mdi-refresh</v-icon>
            {{$translate('Recurring, automatically extended')}}
        </div>

        <div v-else-if="product.period" class="my-1">
            <v-icon color="primary">mdi-calendar-clock</v-icon>
            {{$translate('Valid from')}} {{product.periodValidFrom}} {{$translate('to')}} {{product.periodValidTo}}
        </div>

        <div v-else-if="product.validTime" class="my-1">
            <div v-if="product.validFromDate">
                <v-icon color="primary">mdi-calendar-clock</v-icon>
                {{$translate('Valid until')}} {{ calculateAndFormatEndDate(product.validFromDate) }}
            </div>
            <div v-else>
                <v-icon color="primary">mdi-calendar-clock</v-icon>
                {{$translate('Valid for')}} {{product.validTime}} {{$translate(product.validType + (product.validTime === 1 ? '' : 's')).toLowerCase()}} {{$translate('from purchase')}}
            </div>
        </div>

        <div v-if="product.boundTime" class="my-1">
            <v-icon color="primary">mdi-calendar-clock</v-icon>
            {{$translate('Bound for')}} {{product.boundTime}} {{$translate(product.boundType + (product.boundTime === 1 ? '' : 's')).toLowerCase()}}
        </div>

        <div v-if="product.trainingsessions" class="my-1">
            <v-icon color="primary">mdi-ticket-confirmation-outline</v-icon> {{product.trainingsessions}} {{$translate('Punch tickets').toLowerCase()}}
        </div>

        <div v-if="product.workout" class="my-1">
            <v-icon color="primary">mdi-ticket-confirmation-outline</v-icon> {{$translate('Workout booking included')}}
        </div>

        <div v-if="product.entry" class="my-1">
            <v-icon color="primary">mdi-door-closed-lock</v-icon> {{$translate('Enables on-site access')}}
        </div>

        <v-expansion-panels v-if="includedProducts && includedProducts.length && $api.hasFlag('flag-package-trainingcard')" accordion flat class="mt-2">
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0">
                    <div><v-icon color="primary">mdi-package-variant-closed</v-icon> {{$translate('Products included')}} ({{includedProducts.length}})</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-for="p in includedProducts" :key="p.id" class="d-flex align-center my-1">
                        <v-auto-img :src="p.imagekey" width="40px" height="40px" max-width="40px" max-height="40px" class="mr-2" style="border-radius: 4px" />
                        <div><b>{{p.name}}</b></div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    name: 'zoezi-training-card-product-info',

    zoezi: {
        title: 'Training Card Product Info',
        icon: 'mdi-information'
    },

    props: {
        product: {
            type: Object,
            required: true
        }
    },

    computed: {
        includedProducts() {
            if (!this.product.included_products || !this.product.included_products.length) return [];
            let allProducts = this.$store.getters.allProducts;
            return this.product.included_products
                .map(id => allProducts.find(p => p.id == id))
                .filter(x => x);
        }
    },

    methods: {
        calculateAndFormatEndDate(date) {
            let dateObj = Date.newFull(date);
            dateObj.setDate(dateObj.getDate() - 1);
            return Date.formatFullShorter(dateObj);
        },
    }
};
</script>
